/**
 * Confiança de dispositivo para o 2FA por e-mail (perfil CLIENTEFIEL).
 *
 * Após validar o código com sucesso, marcamos ESTE dispositivo como confiável para
 * aquele e-mail no localStorage. Nos próximos logins do mesmo e-mail nesta máquina, o
 * código não é solicitado novamente.
 *
 * OBS.: é um gate de UX no front (bypassável). O endurecimento real depende do backend.
 */

const PREFIXO = "cf_disp_confiavel_"

// Sem expiração por padrão (0 = nunca expira). Ajuste para limitar por N dias, ex.:
// const TTL_MS = 30 * 24 * 60 * 60 * 1000
const TTL_MS = 0

const normalizarEmail = email => String(email || "").trim().toLowerCase()

const chaveDe = email => PREFIXO + normalizarEmail(email)

/**
 * Este dispositivo já validou o código para este e-mail (e ainda está válido)?
 * @param {string} email
 * @returns {boolean}
 */
export function ehDispositivoConfiavel(email) {
    if (!normalizarEmail(email)) return false
    try {
        const valor = localStorage.getItem(chaveDe(email))
        if (!valor) return false
        if (TTL_MS > 0) {
            const marcadoEm = Number(valor)
            if (!marcadoEm || Date.now() - marcadoEm > TTL_MS) {
                localStorage.removeItem(chaveDe(email))
                return false
            }
        }
        return true
    } catch {
        return false
    }
}

/**
 * Marca este dispositivo como confiável para o e-mail informado.
 * @param {string} email
 */
export function marcarDispositivoConfiavel(email) {
    if (!normalizarEmail(email)) return
    try {
        localStorage.setItem(chaveDe(email), String(Date.now()))
    } catch {
        /* localStorage indisponível: apenas seguimos sem lembrar o dispositivo */
    }
}

/**
 * Mascara o e-mail para exibição, preservando as 2 primeiras letras do local e o domínio.
 * Ex.: "joao@gmail.com" -> "jo***@gmail.com"; "ab@x.com" -> "ab***@x.com".
 * @param {string} email
 * @returns {string}
 */
export function mascararEmail(email) {
    const e = String(email || "").trim()
    const at = e.indexOf("@")
    if (at <= 0) return e
    const local = e.slice(0, at)
    const dominio = e.slice(at) // inclui o "@"
    const visivel = local.slice(0, Math.min(2, local.length))
    return `${visivel}***${dominio}`
}
